import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAlert = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 27 24",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "#ff4d4f",
			d: "M13.5,2.24c.42,0,.84.2,1.08.62l9.96,17.03c.49.84-.11,1.88-1.08,1.88H3.53c-.97,0-1.56-1.05-1.08-1.88L12.42,2.86c.24-.41.66-.62,1.08-.62M13.5,0c-1.25,0-2.38.64-3.01,1.72L.52,18.75c-.63,1.08-.63,2.42-.02,3.5.62,1.08,1.78,1.75,3.03,1.75h19.93c1.24,0,2.41-.67,3.03-1.75.62-1.08.61-2.43-.02-3.5L16.51,1.72c-.63-1.08-1.76-1.72-3.01-1.72h0Z"
		}),
		/* @__PURE__ */ _jsx("circle", {
			fill: "#ff4d4f",
			cx: 13.5,
			cy: 17.7,
			r: 1.58
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#ff4d4f",
			d: "M14.14,14.6h-1.32c-.23,0-.44-.14-.45-.32l-.44-6.19c-.02-.28.27-.5.62-.5h1.85c.37,0,.65.22.62.5l-.44,6.19c-.01.18-.21.32-.45.32h-.01.01Z"
		})
	]
});
export default SvgAlert;
